import React, { useState } from 'react';
import { Button, Icon } from 'semantic-ui-react';
import { showBanner, showMessage } from '../../../helpers/MessageUtility';
import './OcrImageResultModal.scss';
import AiMagic from '../../../icons/AiMagic';

export interface OcrImageResultModalProps {
  imageSrc: string | null;
  ocrResults: string[];
  onClose: () => void;
}

export default function OcrImageResultModal({ imageSrc, ocrResults, onClose }: OcrImageResultModalProps) {
  const [results, setResults] = useState<string[]>(ocrResults || []);

  if (!imageSrc) {
    return null;
  }

  const handleCopyText = (text: string) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        showBanner('Copied to clipboard');
      })
      .catch(() => {
        showMessage('error', 'Could not copy text to clipboard');
      });
  };

  const handleDeleteItem = (index: number) => {
    const newResults = [...results];
    newResults.splice(index, 1);
    setResults(newResults);
  };

  const handleTextChange = (index: number, newValue: string) => {
    const newResults = [...results];
    newResults[index] = newValue;
    setResults(newResults);
  };

  return (
    <div className="ocr-panel">
      <div className="ocr-header">
        <div className="ocr-header-beta">
          <AiMagic large={true} />
          BETA
          <span className="ocr-header-beta-span"> - Pull text from image</span>
        </div>
        <div className="ocr-header-actions">
          <Button className="ocr-close-button" primary onClick={onClose}>
            Close
          </Button>
        </div>
      </div>
      <div className="ocr-result-content">
        <div className="ocr-result-image-container">
          <img src={imageSrc} alt="OCR Source" className="ocr-result-image" />
        </div>
        <div className="ocr-result-beta-text">Review your text below. Copy and paste the results onto your Form.</div>
        <div className="ocr-result-text-container">
          {results.length > 0 ? (
            <ul className="ocr-result-list">
              {results.map((text, index) => (
                <li key={index} className="ocr-result-item">
                  <span
                    contentEditable
                    suppressContentEditableWarning
                    className="ocr-result-text"
                    onBlur={(e) => handleTextChange(index, e.currentTarget.textContent || '')}
                  >
                    {text}
                  </span>
                  <div className="ocr-result-actions">
                    <Button icon className="ocr-copy-button" onClick={() => handleCopyText(text)} title="Copy to clipboard">
                      <Icon name="copy" />
                    </Button>
                    <Button icon className="ocr-delete-button" onClick={() => handleDeleteItem(index)} title="Delete this item">
                      <Icon name="trash" />
                    </Button>
                  </div>
                </li>
              ))}
            </ul>
          ) : (
            <div className="ocr-result-empty">No text was extracted from this image.</div>
          )}
        </div>
      </div>
    </div>
  );
}
